export default {"src":"/_next/static/media/sares-regis.e4d46c67.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};